import React, { useState, useContext, useEffect, useCallback, useRef, ChangeEvent } from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import { filterAirports } from "@/services/airportDetails/filterAirport";
import { checkForInternationalFlights } from "@/services/flightsDetails/checkForInternationalFlights";
import { Box, TextField, InputAdornment, Tooltip, IconButton } from "@mui/material";
import { IconV2 } from "components/V2/atoms/IconV2/IconV2";
import { RadioButtonV2 } from "components/V2/atoms/RadioButtonV2/RadioButtonV2";
import SelectV2 from "components/V2/atoms/SelectV2/SelectV2";
import ShimmerLoader from "components/V2/atoms/ShimmerLoaderV2/ShimmerLoaderV2";
import { CurrencyChangeListV2 } from "components/V2/organisms/CurrencyChangeListV2/CurrencyChangeListV2";
import { AirportsInformation } from "components/V2/organisms/ManageBookings/RetrieveBookingWithMobileFormV2/RetrieveBookingWithMobileFormV2";
import { PricingCalendarV2 } from "components/V2/organisms/PricingCalendarV2/PricingCalendarV2";
import { ButtonV2 } from "components/atoms/ButtonV2/ButtonV2";
import { DEVICE_TYPE_MOBILE } from "constants/viewports";
import dayjs from "dayjs";
import moment from "moment";
import DownArrow from "public/svg/DownArrow";
import { useSelector, useDispatch } from "react-redux";
import { SpecialFareType } from "@/types/*";
import { setNationality } from "@/store/slices/booking";
import { IconBtn } from "../../atom/IconBtn/IconBtn";
import { actionType, eventName, pageName, section } from "../../constants/events/eventName";
import {
  ALLOW_SPECIAL_FARE,
  BOOKING_TYPE,
  DEFAULT_CURRENCY_CODE,
  DEBOUNCE_DELAY,
  NOTIFICATION_MESSAGE_TYPE,
  PROMO_CODE_MAX_LENGTH,
  PROMO_CODE_MIN_LENGTH,
  BOOKING_TYPES_LIST
} from "../../constants/variables";
import { useAuth } from "../../context/AuthContext";
import { BookingDataContext } from "../../context/BookingDataContext";
import { CommonDataContext } from "../../context/CommonDataContext";
import { screenContext } from "../../context/ScreenContext";
import { fetchPromoCodeLength, fetchSpecialfaresRestrictions, fetchStationAliases } from "../../dataLayer/cms";
import { validatePromoCodeAPI } from "../../dataLayer/promoCode";
import validateIsTodayDate from "../../helper/dateValidations/validateIsTodayDate";
import { extractResource } from "../../helper/extractResource";
import { isForSignedInUser } from "../../helper/promocode";
import { getToken } from "../../helper/token";
import PromoApplied from "../../public/svg/Subtract.svg";
import { displayNotificationMessage } from "../../services/notificationMessagePopup";
import { moEngagePush, trackUserActivity } from "../../services/trackUserActivity";
import { addingNewEvent } from "../../store/slices/eventTracking";
import { setOpenSignIn } from "../../store/slices/login";
import { selectWebConfigState, setStoredSearches } from "../../store/slices/webConfig";
import { TripBookingItemType, TripBookingProps } from "../../utils/type";
import { RecentSearchCard } from "../RecentSearchCard";
import { Button } from "../UI/Button";
import Passengers from "../common/Passengers";
import style from "./Booking.module.css";
import SpecialFares from "./SpecialFares";
import SpecialFaresModal from "./SpecialFaresModal";
import styles from "./roundtrip.module.css";

function RoundTrip(props: TripBookingProps) {
  const router = useRouter();
  const {
    origin,
    setOrigin,
    destination,
    setDestination,
    departureDate,
    setDepartureDate,
    arrivalDate,
    setArrivalDate,
    passenger,
    setShowFooter,
    setFareAmount,
    promoCode,
    setPromoCode,
    setPromoCodeStatus,
    setPassenger,
    paxTypesCount, // for retaining the enable and disable buttons in pax details popup
    setPaxTypesCount, // for retaining the enable and disable buttons in pax details popup
    setTripType2,
    setTripType,
    tripType2,
    setTripType: setTripTypeBookingDataContext,
    promoCodeNeedToValidate,
    setPromoCodeNeedToValidate
  } = useContext(BookingDataContext);
  const {
    airports,
    popularAirports,
    passengerTypes,
    setTripType: setTripTypeCommonDataContext,
    setSelectedSpecialFare,
    selectedSpecialFare,
    resources,
    specialFareForPax,
    setSpecialFareForPax,
    prevSpecialFareForPax,
    setPrevSpecialFareForPax,
    selectedCurrency,
    allMarketAvailability,
    setSelectedCurrency,
    promoCodes,
    webConfig
  } = useContext(CommonDataContext);
  const { currentDevice } = useContext(screenContext);
  const { user } = useAuth();
  const enableSignInNeededForValidPromoCode = webConfig?.enableSignInNeededForValidPromoCode ?? false;
  const [originPopper, setOriginPopper] = useState(false);
  const [originCity, setOriginCity] = useState(origin?.cityInfo?.name ?? "");
  const [originData, setOriginData] = useState(popularAirports);
  const [originError, setOriginError] = useState(null);
  const [message, setMessage] = useState("");
  const [isPromoCode, setIsPromoCode] = useState(false);
  const [isValidPromo, setIsValidPromo] = useState(false);
  const [destinationPopper, setDestinationPopper] = useState(false);
  const [destinationError, setDestinationError] = useState(null);
  const [disableSearchBtn, setDisableSearchBtn] = useState(true);
  const [destinationCity, setDestinationCity] = useState(destination?.cityInfo?.name ?? "");
  const [destinationData, setDestinationData] = useState(popularAirports);
  const [tempSpecialFareObj, setTempSpecialFareObj]: any = useState({});
  const [specialFares, setSpecialFares] = useState([]);
  const [isInternationalFlight, setisInternationalFlight] = useState<boolean>(false);
  const [specialfaresRestrictions, setSpecialfaresRestrictions] = useState([]);
  const [rotateChevron, setRotateChevron] = useState(false);
  const [specialFareDialog, setSpecialFareDialog] = useState(false);
  const resourceData = resources;

  const [signInNeededForValidPromoCode, setSignInNeededForValidPromoCode] = useState(false);
  const currentBookingV2 = useSelector((state: any) => state.persistedReducers.booking);
  const dispatch = useDispatch();
  const [currentCouponCode, setCurrentCouponCode] = useState("");
  const { storedSearches } = useSelector(selectWebConfigState);
  const { tripType, handleGroupBookingSuccess, showLoaderOnSubmit, setShowLoaderOnSubmit, isFromModifyBooking } = props;
  const [filteredCurrencies, setFilteredCurrencies] = useState<Array<string>>();
  const [selectedCurrencyLocal, setSelectedCurrencyLocal] = useState<string>(selectedCurrency);
  const [intputPromoCode, setInputPromoCode] = useState(promoCode);
  const [destinationBoxHeight, setDestinationBoxHeight] = useState<number>(0);
  const destinationContainer = useRef<HTMLDivElement | null>(null);
  const [isRequireNationality, setRequireNationality] = useState(false);
  const [countryNames, setCountryNames] = useState([]);
  const { countryList } = useContext(CommonDataContext);
  const [stationAliases, setStationAliases] = useState([]);
  const selectNationality = useSelector((state: any) => state.persistedReducers.booking?.nationality);
  const destinationInputRef = useRef<HTMLInputElement>(null);
  const [promoCodeMaxLength, setPromoCodeMaxLength] = useState()
  
  useEffect(() => {
    const filteredCurrencies = checkForInternationalFlights({ origin, destination })
      ? Array.from(new Set<string>([DEFAULT_CURRENCY_CODE, destination?.currencyCode, origin?.currencyCode]))
      : undefined;
    setFilteredCurrencies(filteredCurrencies);
  }, [destination, origin]);

  const swap = () => {
    setRotateChevron(!rotateChevron);
    setOriginCity(destinationCity);
    setDestinationCity(originCity);
    setOrigin(destination);
    setDestination(origin);
    setSelectedCurrencyLocal(destination?.currencyCode);
  };

  // Origin
  const filterOriginData = (e) => {
    setOriginCity(e?.target?.value);
    setOriginPopper(true);
    if (!e?.target?.value) {
      setOriginError(false);
      setOriginData(popularAirports);
    } else if (e?.target?.value === " ") {
      setOriginError(extractResource(resourceData, "errInvalidAirportSearch"));
      setDisableSearchBtn(true);
      setOriginData(null);
      setOriginPopper(false);
    } else {
      const data = airports?.filter(
        (item: { fullName: any; shortName: any; stationCode: any; cityInfo: { name: string } }) =>
          JSON.stringify(item?.fullName)?.toLowerCase().includes(e?.target?.value?.toLowerCase()) ||
          JSON.stringify(item?.shortName)?.toLowerCase().includes(e?.target?.value?.toLowerCase()) ||
          JSON.stringify(item?.cityInfo?.name)?.toLowerCase().includes(e?.target?.value?.toLowerCase()) ||
          JSON.stringify(item?.stationCode)?.toLowerCase().includes(e?.target?.value?.toLowerCase())
      );
      if (data?.length === 0) {
        setOriginError(extractResource(resourceData, "errInvalidAirportSearch"));
        setDisableSearchBtn(true);
        setOriginData(null);
        // setOriginPopper(false);
      } else {
        setOriginError(false);
        setOriginPopper(true);
        setOriginData(data);
      }
    }
  };

  const handleOriginCity = (item: AirportsInformation) => {
    if (
      item?.locationDetails?.countryCode !== "IN" &&
      Object.keys(selectedSpecialFare).length !== 0 &&
      !specialfaresRestrictions.includes(selectedSpecialFare?.passengerTypeCode)
    ) {
      setSelectedSpecialFareLocal({});
      displayNotificationMessage(
        NOTIFICATION_MESSAGE_TYPE.ERROR,
        extractResource(resourceData, "specialFareRestrictionMessage")
      );
    }
    setOrigin(item);
    setOriginCity(item?.cityInfo?.name);
    setOriginPopper(false);
    setSelectedCurrencyLocal(item?.currencyCode);
    setTimeout(() => {
      if (destinationInputRef.current) {
        destinationInputRef.current.focus();
        openDestinationPopper();
      }
    }, 1400);
  };

  const openOriginPopper = () => {
    setOriginPopper(true);
    setDestinationPopper(false);
  };

  const closeOriginPopper = () => {
    setOriginPopper(false);
    setDestinationPopper(false);
  };
  // Destination

  const filterDestinationData = (e) => {
    setDestinationCity(e?.target?.value);
    setDestinationPopper(true);
    if (!e?.target?.value) {
      setDestinationError(false);
      setDestinationData(popularAirports);
    } else if (e?.target?.value === " ") {
      setDestinationError(extractResource(resourceData, "errInvalidAirportSearch"));
      setDisableSearchBtn(true);
      setDestinationData(null);
      setDestinationPopper(false);
    } else {
      const data = airports?.filter(
        (item: { fullName: any; shortName: any; stationCode: any; cityInfo: { name: string } }) =>
          JSON.stringify(item?.fullName)?.toLowerCase().includes(e?.target?.value?.toLowerCase()) ||
          JSON.stringify(item?.shortName)?.toLowerCase().includes(e?.target?.value?.toLowerCase()) ||
          JSON.stringify(item?.cityInfo?.name)?.toLowerCase().includes(e?.target?.value?.toLowerCase()) ||
          JSON.stringify(item?.stationCode)?.toLowerCase().includes(e?.target?.value?.toLowerCase())
      );

      if (data?.length === 0) {
        setDestinationError(extractResource(resourceData, "errInvalidAirportSearch"));
        setDisableSearchBtn(true);
        setDestinationData(null);
        // setDestinationPopper(false);
      } else {
        setDestinationError(false);
        setDestinationPopper(true);
        setDestinationData(data);
      }
    }
  };

  const handleDestinationCity = (item: AirportsInformation) => {
    if (
      item?.locationDetails?.countryCode !== "IN" &&
      Object.keys(selectedSpecialFare).length !== 0 &&
      !specialfaresRestrictions.includes(selectedSpecialFare?.passengerTypeCode)
    ) {
      setSelectedSpecialFareLocal({});
      displayNotificationMessage(
        NOTIFICATION_MESSAGE_TYPE.ERROR,
        extractResource(resourceData, "specialFareRestrictionMessage")
      );
    }
    setDestination(item);
    setDestinationCity(item?.cityInfo.name);
    setDestinationPopper(false);
  };

  useEffect(() => {
    const fetchStationAliasess = async () => {
      const aliases = await fetchStationAliases();
      setStationAliases(aliases);
    };
    fetchStationAliasess();
  }, []);

  useEffect(() => {
    const respData = async () => {
      const promoCodeMaxLength = await fetchPromoCodeLength();
      setPromoCodeMaxLength(promoCodeMaxLength);
    };
    respData();
  }, [setPromoCodeMaxLength]);

  useEffect(() => {
    const fetchAndSetNationalityRequirement = async () => {
      if (!stationAliases.length) return;
      const originStation = stationAliases?.find((station) => station.code === origin?.stationCode);
      const destinationStation = stationAliases?.find((station) => station.code === destination?.stationCode);
      const requireNationality = originStation?.require_nationality || destinationStation?.require_nationality || false;
      setRequireNationality(requireNationality);
    };
    fetchAndSetNationalityRequirement();
  }, [destination?.stationCode, origin?.stationCode, stationAliases]);

  const openDestinationPopper = () => {
    setDestinationPopper(true);
    setOriginPopper(false);
  };

  const validatePromocodeText = async (
    couponCode: any,
    origin,
    destination,
    departureDate,
    arrivalDate,
    passenger,
    tripType
  ) => {
    try {
      if (couponCode && currentDevice === DEVICE_TYPE_MOBILE) {
        setCurrentCouponCode(couponCode);
        setInputPromoCode(couponCode);

        const params: any = {
          promoCode: couponCode,
          origin: origin?.stationCode,
          destination: destination?.stationCode,
          departureDate: dayjs(departureDate).format("YYYY-MM-DDTHH:mm:ss"),
          passengerCount: passenger.total
        };

        if (tripType === BOOKING_TYPE.ROUND_TRIP) {
          params.returnDate = dayjs(arrivalDate).format("YYYY-MM-DDTHH:mm:ss");
        }
        const response = await validatePromoCodeAPI(params);
        if (response.status) {
          setPromoCodeStatus(true);
          setPromoCode(couponCode);
          setMessage(extractResource(resourceData, "promoCodeAppliedWithNoArgs"));
          setIsValidPromo(true);
          setSignInNeededForValidPromoCode(false);
          setPromoCodeNeedToValidate("");
        } else {
          setPromoCodeStatus(false);
          setMessage(response.errorMessage);
          setIsValidPromo(false);
          if (user === null && enableSignInNeededForValidPromoCode && isForSignedInUser(promoCodes, couponCode)) {
            setSignInNeededForValidPromoCode(true);
            setPromoCodeNeedToValidate(couponCode);
          } else {
            setSignInNeededForValidPromoCode(false);
            setPromoCodeNeedToValidate("");
          }
        }
      }
    } catch (error) {
      console.warn(error);
      setMessage(extractResource(resourceData, "errInvalidPromo"));
      setIsValidPromo(false);
    }
  };

  const searchFlights = async (e: React.MouseEvent<HTMLButtonElement>) => {
    // Todo :: need to add validation, for date and location selectional
    setSelectedCurrency(selectedCurrencyLocal);
    validatePromocodeText(intputPromoCode, origin, destination, departureDate, arrivalDate, passenger, tripType);
    e.preventDefault();
    await getToken(true);
    localStorage.setItem("activeBookingState", "0");
    try {
      if (!origin) {
        setOriginError(extractResource(resourceData, "chooseOrigin"));
      }
      if (!destination) {
        setDestinationError(extractResource(resourceData, "chooseDestination"));
      }
      if (!origin && !destination) {
        setOriginError(extractResource(resourceData, "chooseOrigin"));
        setDestinationError(extractResource(resourceData, "chooseDestination"));
      } else {
        setShowLoaderOnSubmit(!showLoaderOnSubmit);
        setShowFooter(false);
        setFareAmount(null);
        e.preventDefault();

        setTripTypeCommonDataContext(tripType);
        setTripTypeBookingDataContext(tripType);

        // set the spcial fare in context;
        // setSelectedSpecialFare(tempSpecialFareObj);
        setPrevSpecialFareForPax({
          prev: "",
          current: ""
        }); // reset the previous selecetd special fare

        const flightSearchAttributes = {
          origin: origin.cityInfo.cityCode,
          destination: destination.cityInfo.cityCode,
          journeyType: tripType,
          departureDate: new Date(departureDate),
          arrivalDate: arrivalDate ? new Date(arrivalDate) : null,
          specialFare: specialFareForPax ?? null ,
          adult: passenger.adult,
          children: passenger.child,
          infant: passenger.infant,
          seniorCitizen: passenger.seniorcitizen,
          totalPassengers: passenger.total,
          promoCode: promoCode,
          currency: selectedCurrencyLocal,
          source: "Mweb Home Page"
        };

        moEngagePush(eventName.FLIGHT_SEARCH, flightSearchAttributes);

        trackUserActivity({
          page: pageName.HOME_PAGE,
          section: section.FLIGHT_BOOKING_PANEL,
          actionType: actionType.CLICK,
          value: "search Flight",
          eventName: eventName.FLIGHT_SEARCH,
          details: {
            tripType,
            specialFare: tempSpecialFareObj,
            promoCode,
            origin,
            destination,
            arrivalDate,
            departureDate,
            passenger,
            originOfTrigger: props?.origin,
            currentBookingV2,
            selectedCurrencyLocal
          }
        });
        const eventListName = {
          eventName: eventName.FLIGHT_SEARCH,
          tripType,
          specialFare: tempSpecialFareObj,
          promoCode,
          origin,
          destination,
          arrivalDate: moment(arrivalDate).format("DD-MM-YYYY HH:MM"),
          departureDate: moment(departureDate).format("DD-MM-YYYY HH:MM"),
          passenger,
          originOfTrigger: props?.origin,
          currentBookingV2
        };
        // adding this to stack, for futher check;
        dispatch(addingNewEvent(eventListName));

        const item = {
          origin,
          destination,
          departureDate,
          arrivalDate,
          passenger,
          type: tripType === BOOKING_TYPE.ONE_WAY ? BOOKING_TYPE.ONE_WAY : BOOKING_TYPE.ROUND_TRIP,
          paxTypesCount
        };
        // store search in localstorage
        dispatch(setStoredSearches(item));

        router.push("/flight-search");
      }
    } catch (error) {
      console.warn(error);
    }
  };

  // promo code functionality
  const validatePromoCode = async (event: any) => {
    const trimmedPromoCode = event.target.value.trim().replace(/(?<=\w)\s+(?=\w)/g, "").replace(/[^a-zA-Z0-9]/g, "");
    if (trimmedPromoCode?.length <= promoCodeMaxLength) {
      setCurrentCouponCode(trimmedPromoCode.toUpperCase());
      if (trimmedPromoCode?.length > PROMO_CODE_MIN_LENGTH && trimmedPromoCode?.length <= promoCodeMaxLength) {
        debounceValidatePromoCodeText(
          trimmedPromoCode.toUpperCase(),
          origin,
          destination,
          departureDate,
          arrivalDate,
          passenger,
          tripType
        );
      } else {
        setIsValidPromo(false);
        setMessage("");
      }
    }
  };
  const handleChange = (event: any) => {
    if (event.target.name === "promoCode") validatePromoCode(event);
  };

  const setSpecialFareValue = (spFaresObj) => {
    if (typeof spFaresObj.name !== "undefined") {
      setSpecialFareForPax(spFaresObj.name);

      const updatedSpecialFareObj = {
        prev: prevSpecialFareForPax.current,
        current: spFaresObj.name
      };

      setPrevSpecialFareForPax(updatedSpecialFareObj);
    } else {
      setSpecialFareForPax("");
    }
  };

  const setSelectedSpecialFareLocal = (spFaresObj: any) => {
    if (!specialfaresRestrictions.includes(spFaresObj?.passengerTypeCode)) {
      if ((originCity === "" || destinationCity === "") && Object.keys(spFaresObj).length !== 0) {
        displayNotificationMessage(
          NOTIFICATION_MESSAGE_TYPE.ERROR,
          extractResource(resourceData, "specialFareRestrictionMessage")
        );
      } else {
        setSelectedSpecialFare(spFaresObj);
        setSpecialFareValue(spFaresObj);
      }
      if (!isInternationalFlight) {
        setSelectedSpecialFare(spFaresObj);
        if (spFaresObj?.name !== null) {
          setTempSpecialFareObj(spFaresObj);
        } else {
          setTempSpecialFareObj({});
        }
        setSpecialFareValue(spFaresObj);
      }
    } else {
      setSelectedSpecialFare(spFaresObj);
      if (spFaresObj?.name !== null) {
        setTempSpecialFareObj(spFaresObj);
      } else {
        setTempSpecialFareObj({});
      }
      setSpecialFareValue(spFaresObj);
    }
  };

  const selectRecentSearch = (item: TripBookingItemType) => {
    try {
      const newDepartureDate = validateIsTodayDate(item?.departureDate);
      const newTripType = item.type === BOOKING_TYPE.ONE_WAY ? BOOKING_TYPE.ONE_WAY : BOOKING_TYPE.ROUND_TRIP;

      setOriginPopper(false);
      setOrigin(item.origin);
      setOriginCity(item.origin?.cityInfo?.name);
      setDestination(item.destination);
      setDestinationCity(item.destination?.cityInfo?.name);
      if (item?.arrivalDate) {
        setArrivalDate(new Date(item?.arrivalDate));
      }
      setDepartureDate(new Date(newDepartureDate));
      setPassenger({
        adult: item.passenger?.adult,
        seniorcitizen: item.passenger?.seniorcitizen,
        child: item.passenger?.child,
        infant: item.passenger?.infant,
        extraSeat: item.passenger?.extraSeat,
        total: item.passenger?.total
      });
      setDestinationPopper(false);
      props.setTripType(newTripType); // setTripTypeBookingDataContext
      setTripType(newTripType);
      setTripType2(newTripType);
      setSelectedCurrencyLocal(item?.origin?.currencyCode);
    } catch (error) {
      console.error("Error occurred during recent search selection (mobile):", error);
    }
  };

  const closeSpecialFareDialog = () => {
    setSpecialFareDialog(false);
  };
  const openSpecialFareDialog = () => {
    setSpecialFareDialog(true);
  };

  const setPassengerLocal = (pax) => {
    setPassenger(pax);
  };

  const getSpecialFaresRestriction = async () => {
    const specialFaresRestrictionsResponse = await fetchSpecialfaresRestrictions();
    let specialFaresRestrictionsList: any = [];
    specialFaresRestrictionsResponse.forEach((sp: any) => {
      if (sp?.isApplicableForInternational) {
        specialFaresRestrictionsList = [...specialFaresRestrictionsList, sp?.code];
      }
    });
    setSpecialfaresRestrictions(specialFaresRestrictionsList);
  };

  const redirectToSign = () => {
    dispatch(setOpenSignIn({ openSignIn: true }));
  };

  useEffect(() => {
    if (
      (originCity !== "" && origin && origin?.locationDetails.countryCode !== "IN") ||
      (destinationCity !== "" && destination && destination?.locationDetails.countryCode !== "IN")
    ) {
      setisInternationalFlight(true);
    } else {
      setisInternationalFlight(false);
    }
  }, [origin, destination, originCity, destinationCity]);

  useEffect(() => {
    if (!originCity || !destinationCity) {
      setDisableSearchBtn(true);
    } else {
      setDisableSearchBtn(false);
    }
    const specialFareList = passengerTypes?.filter((item: { passengerTypeCode: string }) => {
      return ALLOW_SPECIAL_FARE.includes(item?.passengerTypeCode);
    });
    setSpecialFares(specialFareList);
    getSpecialFaresRestriction();
  }, []);

  useEffect(() => {
    if (promoCode !== "") {
      validatePromocodeText(promoCode, origin, destination, departureDate, arrivalDate, passenger, tripType);
    }
  }, []);

  useEffect(() => {
    validatePromocodeText(intputPromoCode, origin, destination, departureDate, arrivalDate, passenger, tripType);
  }, [user]);

  useEffect(() => {
    if (!originCity || !destinationCity) {
      setDisableSearchBtn(true);
    } else {
      setDisableSearchBtn(false);
    }
  }, [originCity, destinationCity]);
  // roundtrip departure and arrival date logic
  useEffect(() => {
    if (!arrivalDate || new Date(departureDate) > new Date(arrivalDate)) {
      if (props.tripType === BOOKING_TYPE.ROUND_TRIP) {
        const returnDate = new Date(departureDate);
        returnDate.setDate(returnDate.getDate() + 1);
        setArrivalDate(returnDate);
      }
    }
  }, [departureDate, props.tripType]);

  useEffect(() => {
    if (specialFareForPax !== "" && specialFareForPax != null) {
      setPromoCode("");
      setIsPromoCode(true);
    } else {
      setIsPromoCode(false);
    }
  }, [specialFareForPax]);

  function debounceV2(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }
  const debounceValidatePromoCodeText = useCallback(
    debounceV2((couponCode, origin, destination, departureDate, arrivalDate, passenger, tripType) => {
      validatePromocodeText(couponCode, origin, destination, departureDate, arrivalDate, passenger, tripType);
    }, DEBOUNCE_DELAY),
    []
  );
  useEffect(() => {
    if (promoCode !== "") {
      debounceValidatePromoCodeText(promoCode, origin, destination, departureDate, arrivalDate, passenger, tripType);
    }
  }, [origin, destination, arrivalDate, departureDate, passenger]);
  const updateDestinationAirport = async () => {
    if (origin?.stationCode) {
      const destinationAirportList = filterAirports(airports, allMarketAvailability, origin.stationCode);
      setDestinationData(destinationAirportList);
    }
  };
  useEffect(() => {
    updateDestinationAirport();
  }, [origin]);

  const handleApplyNudge = () => {
    const promoCodePattern = /code (\w+)/;
    const nudgeText = extractResource(resourceData, "searchWidgetPromocodeMessage");
    const match = nudgeText.match(promoCodePattern);
    if (match && match[1]) {
      debounceValidatePromoCodeText(match[1], origin, destination, departureDate, arrivalDate, passenger, tripType);
    }
  };

  useEffect(() => {
    if (promoCodeNeedToValidate !== "") {
      setCurrentCouponCode(promoCodeNeedToValidate);
      setInputPromoCode(promoCodeNeedToValidate);
    }
  }, [promoCodeNeedToValidate]);

  useEffect(() => {
    if (destinationContainer) {
      setDestinationBoxHeight(destinationContainer?.current?.clientHeight);
    }
  }, [originPopper, destinationPopper]);

  useEffect(() => {
    setCountryNames(
      countryList
        ?.slice()
        ?.sort((a, b) => {
          if (a.name === "India") return -1;
          if (b.name === "India") return 1;
          return a.name.localeCompare(b.name);
        })
        ?.map((country) => ({ label: country.name, value: country.countryCode })) ?? []
    );
  }, [countryList]);

  const handleChangeNationality = (selectedOption: any) => {
    dispatch(setNationality(selectedOption));
  };

  useEffect(() => {
    if (!isFromModifyBooking) {
      dispatch(setNationality(""));
    }
  }, []);

  const handleTripType = (event: ChangeEvent<HTMLInputElement>) => {
    setTripType(event?.target?.value);
    setTripType2(event?.target?.value);
  };

  const marginTopValue = destinationCity ? "-13px !important" : "-8px !important";

  return (
    <form className="mobile-search-panel pb-2">
      <Box
        className={
          props.tripType === BOOKING_TYPE.ONE_WAY
            ? `${style.search_upper} px-4`
            : `${style.gap_round} ${style.subSection}  mt-4 px-4`
        }
      >
        <Box className={style.autoComplete_box}>
          <Box className={style.autoComplete}>
            <TextField
              value={originCity}
              onClick={openOriginPopper}
              onChange={filterOriginData}
              onFocus={openOriginPopper}
              variant="standard"
              autoComplete="off"
              label={<p className="text-typography-primary">{extractResource(resourceData, "from")}</p>}
              className={originCity ? `${style.search_input_oneway} mt-3` : style.search_input_oneway}
              InputProps={{
                disableUnderline: true
              }}
            />
            {originPopper ? (
              <Box onPointerEnter={() => setOriginPopper(true)} className="popper">
                <div className={style.closePopup}>
                  <p className={style.fromToPopup}>
                    {extractResource(resourceData, "flying").replace("{}", extractResource(resourceData, "from"))}
                  </p>
                  <div onClick={closeOriginPopper}>
                    <IconV2
                      blok={{
                        component: "icon",
                        icon: "cross-black",
                        height: 24,
                        width: 24,
                        alt: "clear Icon"
                      }}
                    />
                  </div>
                </div>
                <div className={style.filterData}>
                  <TextField
                    onChange={filterOriginData}
                    value={originCity}
                    variant="standard"
                    autoComplete="off"
                    error={!!originError}
                    label={extractResource(resourceData, "searchPanelPlaceholder")}
                    InputLabelProps={{
                      style: {
                        color: "#666666"
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <IconButton color="inherit">
                          <IconV2
                            blok={{
                              component: "icon",
                              icon: "search-icon",
                              height: 20,
                              width: 20,
                              alt: "Search Icon"
                            }}
                          />
                        </IconButton>
                      )
                    }}
                    helperText={originError ? <p className="text-xs helper_red">{originError}</p> : null}
                    autoFocus
                  />
                </div>
                {storedSearches?.length !== 0 ? (
                  <Box className="recentSearches">
                    <div className="text-sm font-semibold">
                      {extractResource(resourceData, "recentStationSearches")}
                    </div>
                    <Box className={styles.recentSearchList}>
                      {Array.isArray(storedSearches) &&
                        storedSearches?.map((item: any) => (
                          <RecentSearchCard
                            origin={item?.origin}
                            destination={item?.destination}
                            type={item?.type}
                            handleOnClick={() => selectRecentSearch(item)}
                            key={`${item?.origin?.stationCode?.toLowerCase()}-${item?.destination?.stationCode.toLowerCase()}`}
                          />
                        ))}
                    </Box>
                  </Box>
                ) : null}

                <h3 className="text-sm font-semibold text-typography-primary">
                  {extractResource(resourceData, "popularCities")}
                </h3>
                {originData && originData?.length > 0 ? (
                  originData
                    ?.filter(
                      (item: any) =>
                        item?.stationCode !== destination?.stationCode &&
                        item.stationCode &&
                        item.shortName &&
                        item.fullName &&
                        item.cityInfo.name
                    )
                    .map((item: any, index: number) => (
                      <div key={index}>
                        <Box
                          key={item?.stationCode}
                          onClick={() => handleOriginCity(item)}
                          component="li"
                          className="roundTrip_option"
                        >
                          <Box className="roundTrip_option_left">
                            <span className="roundTrip_option_left_text">{item?.stationCode}</span>
                          </Box>
                          <Box className={styles.roundTrip_option_right}>
                            <h5 className="roundTrip_option_right_text_lg">{item?.cityInfo?.name}</h5>
                            <h6 className="roundTrip_option_right_text_md">{item?.fullName}</h6>
                          </Box>
                        </Box>
                        <hr className="mx-4 border-gray-150" />
                      </div>
                    ))
                ) : (
                  <div ref={destinationContainer} className="h-full">
                    <ShimmerLoader
                      parentHeight={destinationBoxHeight}
                      containerClass="w-[95%] mx-auto mt-4"
                      boxClass="h-[50px]"
                    />
                  </div>
                )}
              </Box>
            ) : null}
          </Box>

          <Box
            className={`flex items-center text-typography-tertiary mx-3 filters__chevron cursor-pointer px-2 ${
              rotateChevron ? "rotate" : ""
            }`}
            onClick={swap}
          >
            <IconV2
              blok={{
                component: "icon",
                icon: "swap-icon",
                height: 60,
                width: 60,
                alt: "Public Icon"
              }}
              key={""}
              className={""}
            />
          </Box>

          <Box className={style.autoComplete}>
            <TextField
              sx={{
                "& label": {
                  width: "100%",
                  textAlign: "right",
                  transformOrigin: "right",
                  marginTop: marginTopValue,
                  "&.Mui-focused": {
                    transformOrigin: "right"
                  }
                }
              }}
              value={destinationCity}
              ref={destinationInputRef}
              onClick={openDestinationPopper}
              onChange={filterDestinationData}
              onFocus={openDestinationPopper}
              inputProps={{
                min: 0,
                style: { textAlign: "right" },
                disableUnderline: true
              }}
              variant="standard"
              InputProps={{
                disableUnderline: true
              }}
              autoComplete="off"
              label={<p className="text-typography-primary">{extractResource(resourceData, "to")}</p>}
              helperText={destinationError ? <p className="text-xs helper_red">{destinationError}</p> : null}
              className={destinationCity ? `${style.search_input_oneway} mt-3` : style.search_input_oneway}
            />
            {destinationPopper ? (
              <Box className="popper destination-input-box" onPointerEnter={() => setDestinationPopper(true)}>
                <div className={style.closePopup}>
                  <p className={style.fromToPopup}>
                    {extractResource(resourceData, "flying").replace("{}", extractResource(resourceData, "to"))}
                  </p>
                  <div onClick={closeOriginPopper}>
                    <IconV2
                      blok={{
                        component: "icon",
                        icon: "cross-black",
                        height: 24,
                        width: 24,
                        alt: "clear Icon"
                      }}
                    />
                  </div>
                </div>
                <div className={style.filterData}>
                  <TextField
                    onChange={filterDestinationData}
                    value={destinationCity}
                    variant="standard"
                    autoComplete="off"
                    error={!!destinationError}
                    label={extractResource(resourceData, "searchPanelPlaceholder")}
                    InputLabelProps={{
                      style: {
                        color: "#666666"
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <IconButton color="inherit">
                          <IconV2
                            blok={{
                              component: "icon",
                              icon: "search-icon",
                              height: 20,
                              width: 20,
                              alt: "Search Icon"
                            }}
                          />
                        </IconButton>
                      )
                    }}
                    helperText={
                      destinationError ? <span className="helperText helper_red">{destinationError}</span> : null
                    }
                    autoFocus
                  />
                </div>
                <h3 className="text-sm font-semibold text-typography-primary">
                  {extractResource(resourceData, "popularCities")}
                </h3>
                {destinationData && destinationData?.length > 0 ? (
                  destinationData
                    ?.filter(
                      (item: any) =>
                        item?.stationCode !== destination?.stationCode &&
                        item.stationCode &&
                        item.shortName &&
                        item.fullName &&
                        item.cityInfo.name
                    )
                    .map((item: any, index: number) => (
                      <React.Fragment key={item?.stationCode}>
                        <Box onClick={() => handleDestinationCity(item)} component="li" className="roundTrip_option">
                          <div className="roundTrip_option_left">
                            <span className="roundTrip_option_left_text">{item?.stationCode}</span>
                          </div>
                          <div className="roundTrip_option_right">
                            <h5 className="roundTrip_option_right_text_lg">{item?.cityInfo?.name}</h5>
                            <h6 className="roundTrip_option_right_text_md">{item?.fullName}</h6>
                          </div>
                        </Box>
                        {index < destinationData.length - 1 && <hr className="mx-4 border-gray-150" />}
                      </React.Fragment>
                    ))
                ) : (
                  <div ref={destinationContainer} className="h-full">
                    <ShimmerLoader
                      parentHeight={destinationBoxHeight}
                      containerClass="w-[95%] mx-auto mt-4"
                      boxClass="h-[50px]"
                    />
                  </div>
                )}
              </Box>
            ) : null}
          </Box>
        </Box>

        <div className="flex ml-1 gap-3 py-3 pb-4">
          {BOOKING_TYPES_LIST.map((bookingType: any) => (
            <div key={`booking-type-${bookingType.type}`} className="mr-4">
              <RadioButtonV2
                id={`booking-type-${bookingType.type}`}
                label={extractResource(resourceData, bookingType.title)}
                className="font-bold text-base"
                name="booking-type"
                value={bookingType.type}
                checked={tripType2 === bookingType.type}
                onClick={(selectedValue) => handleTripType({ target: { value: selectedValue } })}
                data_testid={`booking-type-${bookingType.type}`}
              />
            </div>
          ))}
        </div>

        <Box className="datepicker flex justify-between pb-4">
          <div className={style.dateSection}>
            {origin?.stationCode !== "" && destination?.stationCode !== "" && (
              <PricingCalendarV2
                label="Departure Date"
                selectedOptionOrg={origin?.stationCode}
                selectedOptionDest={destination?.stationCode}
                selectedDate={departureDate}
                onChange={(newValue) => {
                  setDepartureDate(newValue);
                }}
                minDate={String(new Date())}
                selectedCurrency={selectedCurrencyLocal}
              />
            )}
          </div>

          <div className={style.dateSection2}>
            {origin?.stationCode !== "" && destination?.stationCode !== "" && (
              <PricingCalendarV2
                label={
                  tripType === BOOKING_TYPE.ROUND_TRIP ? (
                    <span className="!ml-[82px] !mt-0 !font-normal text-[18px]">
                      {" "}
                      {extractResource(resourceData, "returnDate")}{" "}
                    </span>
                  ) : (
                    <div className="!ml-0 !-mt-1 !mb-2 !font-normal text-neutral-400 text-[18px]">
                      {" "}
                      {extractResource(resourceData, "addReturnTrip")}{" "}
                    </div>
                  )
                }
                selectedOptionOrg={destination?.stationCode}
                selectedOptionDest={origin?.stationCode}
                selectedDate={arrivalDate}
                onChange={(newValue) => {
                  setArrivalDate(newValue);
                }}
                minDate={String(departureDate)}
                selectedCurrency={selectedCurrencyLocal}
              />
            )}
          </div>
        </Box>

        {tripType === BOOKING_TYPE.ONE_WAY ? (
          <>
            <div className="pb-1">
              <Box className={currentCouponCode ? "pb-3" : ""}>
                <Passengers
                  resourceData={resourceData}
                  specialFareForPax={specialFareForPax}
                  setPassenger={setPassengerLocal}
                  passenger={passenger}
                  paxTypesCount={paxTypesCount} // for retaining the enable and disable buttons in pax details popup
                  setPaxTypesCount={setPaxTypesCount} // for retaining the enable and disable buttons in pax details popup
                  prevSpecialFareForPax={prevSpecialFareForPax}
                  setSpecialFareForPax={setSpecialFareForPax}
                  selectedSpecialFare={selectedSpecialFare}
                />
              </Box>

              <Tooltip title={isPromoCode ? extractResource(resourceData, "promoCodeRemoved") : ""} arrow>
                {/* one way promo code */}
                <TextField
                  id="outlined-basic"
                  label={<p className="text-typography-primary">{extractResource(resourceData, "promoCode")}</p>}
                  variant="outlined"
                  defaultValue={intputPromoCode || ""}
                  value={currentCouponCode}
                  disabled={!!isPromoCode}
                  className={style.roundTripPromo}
                  onChange={handleChange}
                  name="promoCode"
                  InputLabelProps={{
                    style: {
                      color: "#666666"
                    }
                  }}
                  sx={{
                    fontWeight: "",
                    "& .MuiFormHelperText-root": {
                      marginLeft: 0,
                      marginRight: 0,
                      marginTop: 0,
                      marginBottom: 1
                    }
                  }}
                  helperText={
                    intputPromoCode !== "" ? (
                      isValidPromo ? (
                        <span className="helperText helper_green">{message}</span>
                      ) : signInNeededForValidPromoCode ? (
                        <div>
                          <span className="helperText helper_red">{message}</span>
                          <span
                            className="text-typography-tertiary font-medium text-xs cursor-pointer ml-1"
                            onClick={redirectToSign}
                          >
                            {extractResource(resourceData, "signIn")}
                          </span>
                        </div>
                      ) : (
                        <span className="helperText helper_red">{message}</span>
                      )
                    ) : null
                  }
                  InputProps={{
                    endAdornment:
                      isValidPromo && promoCode !== "" ? (
                        <InputAdornment position="end">
                          <Image src={PromoApplied} />
                        </InputAdornment>
                      ) : null
                  }}
                />
              </Tooltip>

              {/* Show sections when no promo code is entered or after clearing the field */}
              {currentCouponCode === "" && enableSignInNeededForValidPromoCode && (
                <div className="flex justify-between items-center w-full">
                  {/* Left Section: Icon + Promo Message */}
                  <div className="flex items-center gap-1">
                    <IconV2
                      blok={{
                        component: "icon",
                        icon: "circle-wavy-icon",
                        height: 20,
                        width: 20,
                        alt: "Public Icon"
                      }}
                    />

                    <div className="font-normal text-xs">
                      {(() => {
                        const message = extractResource(resourceData, "searchWidgetPromocodeMessage");
                        const regex = /(.*Use code\s+)(\S+)(.*)/i;
                        const matches = message.match(regex);

                        if (matches) {
                          return (
                            <>
                              {matches[1]}
                              <ButtonV2 className="text-typography-tertiary font-medium" onClick={handleApplyNudge}>{matches[2]}</ButtonV2>
                            </>
                          );
                        }
                        return message;
                      })()}
                    </div>
                  </div>

                  {/* Right Section: Apply Button */}
                  <ButtonV2 className="font-medium text-typography-tertiary text-xs" onClick={handleApplyNudge}>
                    {extractResource(resourceData, "apply")}
                  </ButtonV2>
                </div>
              )}
            </div>
          </>
        ) : null}
      </Box>

      {props.tripType === BOOKING_TYPE.ROUND_TRIP ? (
        <Box className={`px-4 pb-1 ${style.subSection} ${style.gap_round}`}>
          <Box className={currentCouponCode ? "pb-3" : ""}>
            <Passengers
              resourceData={resourceData}
              specialFareForPax={specialFareForPax}
              setPassenger={setPassengerLocal}
              passenger={passenger}
              paxTypesCount={paxTypesCount} // for retaining the enable and disable buttons in pax details popup
              setPaxTypesCount={setPaxTypesCount} // for retaining the enable and disable buttons in pax details popup
              prevSpecialFareForPax={prevSpecialFareForPax}
              setSpecialFareForPax={setSpecialFareForPax}
              selectedSpecialFare={selectedSpecialFare}
            />
          </Box>

          <Tooltip title={isPromoCode ? extractResource(resourceData, "promoCodeRemoved") : ""} arrow>
            {/* round trip promo code */}
            <TextField
              id="outlined-basic"
              label={<p className="text-typography-primary">{extractResource(resourceData, "promoCode")}</p>}
              variant="outlined"
              defaultValue={intputPromoCode || ""}
              value={currentCouponCode}
              disabled={!!isPromoCode}
              className={style.roundTripPromo}
              onChange={handleChange}
              name="promoCode"
              InputLabelProps={{
                style: {
                  color: "#666666"
                }
              }}
              sx={{
                fontWeight: "",
                "& .MuiFormHelperText-root": {
                  marginLeft: 0,
                  marginRight: 0,
                  marginTop: 0,
                  marginBottom: 1
                }
              }}
              helperText={
                intputPromoCode !== "" ? (
                  isValidPromo ? (
                    <span className="helperText helper_green">{message}</span>
                  ) : signInNeededForValidPromoCode ? (
                    <div>
                      <span className="helperText helper_red">{message}</span>
                      <span
                        className="text-typography-tertiary font-medium text-xs cursor-pointer ml-1"
                        onClick={redirectToSign}
                      >
                        {extractResource(resourceData, "signIn")}
                      </span>
                    </div>
                  ) : (
                    <span className="helperText helper_red">{message}</span>
                  )
                ) : null
              }
              InputProps={{
                endAdornment:
                  isValidPromo && promoCode !== "" ? (
                    <InputAdornment position="end">
                      <Image src={PromoApplied} />
                    </InputAdornment>
                  ) : null
              }}
            />
          </Tooltip>
          {currentCouponCode === "" && enableSignInNeededForValidPromoCode && (
            <div className="flex justify-between items-center w-full">
              {/* Left Section: Icon + Promo Message */}
              <div className="flex items-center gap-1">
                <IconV2
                  blok={{
                    component: "icon",
                    icon: "circle-wavy-icon",
                    height: 20,
                    width: 20,
                    alt: "Public Icon"
                  }}
                />

                <div className="font-normal text-xs">
                  {(() => {
                    const message = extractResource(resourceData, "searchWidgetPromocodeMessage");
                    const regex = /(.*Use code\s+)(\S+)(.*)/i;
                    const matches = message.match(regex);

                    if (matches) {
                      return (
                        <>
                          {matches[1]}
                          <ButtonV2 className="text-typography-tertiary font-medium" onClick={handleApplyNudge}>{matches[2]}</ButtonV2>
                        </>
                      );
                    }
                    return message;
                  })()}
                </div>
              </div>

              {/* Right Section: Apply Button */}
              <ButtonV2 className="font-medium text-typography-tertiary text-xs" onClick={handleApplyNudge}>
                {extractResource(resourceData, "apply")}
              </ButtonV2>
            </div>
          )}
        </Box>
      ) : null}

      <div className="px-4 pb-2">
        <CurrencyChangeListV2
          selectedCurrency={selectedCurrencyLocal}
          setSelectedCurrency={setSelectedCurrencyLocal}
          filterCurrencies={filteredCurrencies}
        />
      </div>

      <div className="mt-2 px-4 pb-2">
        {isRequireNationality && (
          <SelectV2
            endAdornment={<DownArrow className="!mr-1 h-5 w-5" style={{ fill: "black" }} />}
            id="selectNationality"
            options={countryNames}
            preSelectedValue={isFromModifyBooking ? selectNationality?.label : ""}
            label={extractResource(resourceData, "selectNationality")}
            placeholder={extractResource(resourceData, "selectNationality")}
            onChange={handleChangeNationality}
            additionalWrapperClassNames="w-full h-200 text-lg"
            ellipsis
            viewHeight="h-14 pt-0"
            variant="underline"
          />
        )}
      </div>

      <Box className={style.search_lower}>
        <div className="opacity-1">
          <Box className="flex items-start gap-2 pl-4">
            <Box className={`${style.search_lower_box} flex-shrink-0`}>
              <p className="flex items-center gap-1 mt-2">
                <span className="text-sm text-typography-secondary font-medium">
                  {extractResource(resourceData, "specialFares")}
                </span>
                <IconBtn onClick={openSpecialFareDialog}>
                  <IconV2
                    blok={{
                      component: "icon",
                      icon: "info",
                      height: 14,
                      width: 14,
                      alt: "Public Icon"
                    }}
                  />
                </IconBtn>
              </p>
            </Box>
            {specialFareDialog ? (
              <SpecialFaresModal
                specialFareDialog={specialFareDialog}
                closeSpecialFareDialog={closeSpecialFareDialog}
              />
            ) : null}
            <div className="scrollbar-hidden mt-0 mb-6 pb-1 flex-grow flex items-center gap-4 sm:gap-8 overflow-x-scroll overflow-y-hidden whitespace-nowrap">
              {specialFares?.map((item: SpecialFareType) => {
                const isDisabled = isInternationalFlight && !specialfaresRestrictions.includes(item?.passengerTypeCode);
                return (
                  <SpecialFares
                    isDisabled={isDisabled}
                    key={item?.passengerTypeCode}
                    setSpecialFareForPax={setSpecialFareForPax}
                    specialFareForPax={specialFareForPax}
                    label={item?.name}
                    spFares={item}
                    selectedSpecialFare={selectedSpecialFare}
                    setSelectedSpecialFare={setSelectedSpecialFareLocal}
                  />
                );
              })}
            </div>
          </Box>
        </div>

        <div className="mx-4">
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={searchFlights}
            disabled={disableSearchBtn}
            isLoading={showLoaderOnSubmit}
            type="submit"
          >
            {extractResource(resourceData, "searchFlights")}
          </Button>
        </div>
        {/* {!(isValidPromo && extractResource(resourceData, "searchWidgetPromocodeMessage").includes(intputPromoCode)) && enableSignInNeededForValidPromoCode
          && <div className="flex justify-center">
          <ButtonV2 className="text-typography-tertiary font-bold text-xs mt-3" onClick={handleApplyNudge}>{extractResource(resourceData, "searchWidgetPromocodeMessage")}</ButtonV2>
        </div>} */}
      </Box>
    </form>
  );
}

export default RoundTrip;
